import * as yup from 'yup';

const requiredErrorMessage = 'Field is required';

export const createTeamUserSchema = yup.object().shape({
  member: yup.string().required(requiredErrorMessage),
});
